<!--
  Usage in the dashboard's left rail, in the rail's own language.

  The other tiles are pixel-art glyphs in a bordered box that inverts when selected, so this
  is one too: the box and the label are theirs, and inside is a dial that fills as the
  account does. It reads at a glance without numbers, turns amber past 80 per cent and red
  at the limit, and opens the plan page. The figures are on hover, where they belong.
-->
<template>
  <vx-tooltip :text="tooltip" position="right">
    <div
      class="md:w-24 md:h-24 w-16 h-16 flex-shrink-0 cursor-pointer flex flex-col items-center justify-center md:gap-2 gap-1 plan_btn"
      :class="[tone, { plan_clicked: active }]"
      @click="open"
    >
      <svg
        class="plan-ico object-fit w-12 h-12"
        viewBox="0 0 36 36"
        aria-hidden="true"
      >
        <!-- the dial, and how full it is. Thick enough to sit among the pixel glyphs
             rather than looking like a hairline from another product. -->
        <circle class="plan-track" cx="18" cy="18" r="13" pathLength="100" />
        <circle
          class="plan-fill"
          cx="18"
          cy="18"
          r="13"
          pathLength="100"
          :stroke-dasharray="`${dash} 100`"
        />
      </svg>
      <p class="font-semibold md:text-base text-xs">PLAN</p>
    </div>
  </vx-tooltip>
</template>

<script>
import {
  accountSummary,
  currentAccount,
  subscribeAccount,
} from '@/http/requests/account';

export default {
  name: 'UsageTile',
  data() {
    return { acc: currentAccount() };
  },
  computed: {
    /** The fuller of the two meters: whichever is closer to stopping something. */
    worst() {
      if (!this.acc) return null;
      return this.acc.storage.pct >= this.acc.ai.pct
        ? this.acc.storage
        : this.acc.ai;
    },
    /** How much of the dial is drawn. A sliver at zero, so it still reads as a dial. */
    dash() {
      if (!this.worst) return 0;
      return Math.max(3, Math.min(100, this.worst.pct));
    },
    tone() {
      return this.worst ? this.worst.tone : '';
    },
    active() {
      return this.$route.path.startsWith('/dashboard/account');
    },
    tooltip() {
      if (!this.acc) return '/ plan';
      return `${this.acc.planName}: ${this.acc.storage.usedLabel} of ${this.acc.storage.allowedLabel} stored, ${this.acc.ai.usedLabel} of ${this.acc.ai.allowedLabel} AI used`;
    },
  },
  created() {
    this.unsubscribe = subscribeAccount((acc) => {
      this.acc = acc;
    });
    accountSummary().catch(() => {});
  },
  beforeDestroy() {
    if (this.unsubscribe) this.unsubscribe();
  },
  methods: {
    open() {
      if (!this.active) this.$router.push('/dashboard/account');
    },
  },
};
</script>

<style scoped>
.plan_btn {
  background-color: black;
  border: 1px solid white;
  color: white;
}
.plan_clicked {
  background-color: white;
  color: black;
}
.plan-ico {
  transform: rotate(-90deg);
}
.plan-track,
.plan-fill {
  fill: none;
  stroke-width: 4.5;
}
/* the unused part is the dial showing through, not a second colour */
.plan-track {
  stroke: currentColor;
  opacity: 0.22;
}
.plan-fill {
  stroke: currentColor;
  stroke-linecap: butt;
  transition: stroke-dasharray 0.4s;
}
.plan_btn.warn .plan-fill {
  stroke: #f0c45a;
}
.plan_btn.over .plan-fill {
  stroke: #ef4444;
}
</style>
